import { api } from "@/lib/api";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old GitLab-shaped URL, kept so bookmarks land on `/work-item/:globalId`. */
export const Route = createFileRoute("/_app/$group/$project_/-/work_items/$iid")({
  loader: async ({ params }) => {
    const { globalId } = await api.get<{ globalId: number }>(
      `/api/work-items/resolve?project=${encodeURIComponent(params.project)}&iid=${encodeURIComponent(params.iid)}`,
    );
    throw redirect({ to: "/work-item/$id", params: { id: String(globalId) }, replace: true });
  },
});
